/**
 * Default-category display names (F5 Phase 2, decision D4).
 *
 * LAW (LANGUAGE_NJCASH.md §2): stored category names are load-bearing lookup
 * keys (CSV import matching, code lookups, cross-device sync) and are NEVER
 * translated in storage. This module translates ONLY at the display layer:
 *
 * - EXACT match against a known seeded default English name -> catalog label.
 * - Anything else (user-created, renamed, even "Food " with a space) shows
 *   the stored string verbatim. When in doubt, storage wins.
 *
 * English behavior is identical by construction: the en catalog values equal
 * the stored names. Keep this map in sync with db.ts
 * DEFAULT_EXPENSE_CATEGORIES / DEFAULT_INCOME_CATEGORIES.
 */

import { i18n } from './index';

const DEFAULT_NAME_KEYS: Record<string, string> = {
  // Expense defaults (db.ts DEFAULT_EXPENSE_CATEGORIES)
  Food: 'categories.defaults.food',
  Transport: 'categories.defaults.transport',
  Shopping: 'categories.defaults.shopping',
  Bills: 'categories.defaults.bills',
  Entertainment: 'categories.defaults.entertainment',
  Health: 'categories.defaults.health',
  Education: 'categories.defaults.education',
  Other: 'categories.defaults.other',
  // Income defaults (db.ts DEFAULT_INCOME_CATEGORIES; Other shared above)
  Salary: 'categories.defaults.salary',
  Freelance: 'categories.defaults.freelance',
  Investment: 'categories.defaults.investment',
  Gift: 'categories.defaults.gift',
};

/**
 * Display name for a category: localized label for unmodified defaults,
 * the stored name verbatim for everything else.
 */
export function categoryDisplayName(name: string | undefined | null): string {
  if (!name) return '';
  const key = DEFAULT_NAME_KEYS[name];
  return key ? i18n.t(key) : name;
}
